var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoErrorStatus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 381,
    height: 219,
    viewBox: "0 0 381 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.7974 197.215C-18.5991 172.687-18.5991 132.924 55.7974 108.396 130.194 83.8679 250.806 83.8679 325.203 108.396 399.599 132.924 399.599 172.687 325.203 197.215 250.806 221.744 130.194 221.744 55.7974 197.215z",
    fill: "#a2eaf3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9732 179.081C53.0089 170.369 53.0089 156.246 96.9732 147.534 140.937 138.822 212.212 138.822 256.177 147.534 300.141 156.246 300.141 170.369 256.177 179.081 212.212 187.792 140.937 187.792 96.9732 179.081z",
    fill: "#6edfee"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.118 134.838C107.627 128.469 107.627 118.145 145.118 111.777 182.61 105.408 243.39 105.408 280.882 111.777 318.373 118.145 318.373 128.469 280.882 134.838 243.39 141.207 182.61 141.207 145.118 134.838z",
    fill: "#6edfee"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.416 126.423C95.8009 110.177 77.5787 98.24 56.4878 89.9652 35.6497 81.7917 33.3751 68.0679 48.1349 65.4702 64.866 62.5176 83.9602 73.8844 95.4724 87.8997 115.552 112.331 116.412 129.299 116.412 129.299L106.416 126.423z",
    fill: "url(#paint0_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M106.416 126.423C95.8009 110.177 77.5787 98.24 56.4878 89.9652 35.6497 81.7917 33.3751 68.0679 48.1349 65.4702 64.866 62.5176 83.9602 73.8844 95.4724 87.8997 115.552 112.331 116.412 129.299 116.412 129.299L106.416 126.423z",
    fill: "#000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M112.885 126.321C112.973 126.334 113.075 126.321 113.163 126.296 113.492 126.182 113.668 125.814 113.555 125.485 99.6796 85.5554 60.1769 71.4261 50.2317 70.9572 49.8779 70.9445 49.5873 71.2106 49.5746 71.5655 49.562 71.9203 49.8526 72.2118 50.1812 72.2244 59.9115 72.6299 98.7065 86.5945 112.367 125.903 112.443 126.144 112.658 126.296 112.885 126.321z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.512 128.527C116.044 132.442 111.621 134.483 108.361 132.278 97.6451 125.08 81.6849 120.417 55.5393 124.611 40.6279 127.006 33.8545 123.407 31.5041 117.16 28.9009 110.216 36.8115 104.741 45.3161 102.726 74.2797 95.8708 98.5297 105.806 116.512 128.527z",
    fill: "url(#paint1_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M114.502 131.923C114.679 131.948 114.856 131.897 114.995 131.77 115.26 131.542 115.286 131.137 115.046 130.871 93.6136 106.528 55.9686 106.287 40.9181 112.991 40.6022 113.13 40.4506 113.51 40.6022 113.827 40.7412 114.144 41.1203 114.296 41.4362 114.144 56.1834 107.58 93.0829 107.82 114.098 131.707 114.212 131.834 114.351 131.91 114.502 131.923z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M308.704 109.901V115.362C308.704 116.759 307.986 117.914 307.036 118.04L221.843 125.761C221.21 125.849 220.575 125.833 219.946 125.723 219.782 125.693 219.618 125.658 219.454 125.617L160.096 114.429C159.465 114.266 159 113.439 159 112.481V106.712L221.98 98.9053 230.087 95.0677 238.148 96.2293 242.908 95.3171 253.788 98.484 308.704 109.901z",
    fill: "url(#paint2_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M308.703 109.901V115.362C308.703 116.759 307.985 117.914 307.035 118.04L221.846 125.76C221.213 125.848 220.426 125.827 219.953 125.722V96.3067L230.09 95.0664 238.15 96.2279 242.909 95.3158 253.787 98.4826 308.703 109.901z",
    fill: "url(#paint3_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M242.91 95.3158 159.002 106.454 219.524 117.854C220.27 118.044 221.026 118.089 221.776 117.987L308.706 109.901 242.91 95.3158z",
    fill: "url(#paint4_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M273.669 105.377C273.669 109.373 261.093 112.48 243.732 113.285 239.35 113.488 234.665 113.543 229.805 113.431 205.912 112.88 186.713 108.436 186.713 103.514 186.713 103.403 186.726 103.16 186.746 103.161L186.713 103.16 186.813 102.923C186.836 102.841 186.865 102.769 186.902 102.693L192.413 88.2878 199.067 70.9061 208.386 46.5436 215.519 27.8955 224.391 4.70765C225.501 1.80458 227.558.0 229.783.0 230.084.0 230.381.0301844 230.674.0971177 232.55.506593 234.226 2.19699 235.188 4.71289L244.135 28.0635 251.28 46.957 260.708 71.8077V71.813L267.478 89.6684V89.6737L267.585 89.6842 273.224 104.194C273.465 104.583 273.669 104.979 273.669 105.377z",
    fill: "url(#paint5_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M267.586 89.6854C262.146 91.5031 253.45 92.8116 243.038 93.2985 238.842 93.4954 234.404 93.5597 229.779 93.4718 213.725 93.1673 199.807 91.1015 192.398 88.2917L199.059 70.9073C206.853 72.6607 217.716 73.8432 229.791 74.0243 233.695 74.0834 237.5 74.0322 241.122 73.8865 248.746 73.5847 255.468 72.8537 260.765 71.8142L267.477 89.6684V89.6736L267.586 89.6854z",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M251.361 46.9596C247.209 47.4084 242.644 47.7129 237.801 47.8507 235.207 47.9281 232.535 47.9531 229.803 47.9268 221.989 47.8507 214.682 47.3507 208.385 46.5462L215.518 27.898C219.981 28.2497 224.789 28.4518 229.805 28.4807 231.577 28.4912 233.322 28.4807 235.036 28.444 238.179 28.3849 241.227 28.2589 244.135 28.066L251.361 46.9596z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M243.732 113.285C239.35 113.488 234.665 113.543 229.805 113.431 205.912 112.88 186.713 108.436 186.713 103.514 186.713 103.403 186.726 103.16 186.746 103.161L186.713 103.16 186.813 102.923C186.836 102.841 186.865 102.769 186.902 102.693L192.413 88.2878 199.067 70.9061 208.386 46.5436 215.519 27.8955 224.391 4.70765C225.501 1.80458 227.558.0 229.783.0 230.084.0 230.381.0301844 230.674.0971177 231.623 6.00038 233.243 16.3003 235.037 28.4428 235.936 34.556 236.88 41.1378 237.804 47.8495 238.994 56.5311 240.148 65.4464 241.127 73.8879 241.928 80.8056 242.609 87.4045 243.093 93.2986 243.797 101.832 244.087 108.89 243.732 113.285z",
    fill: "url(#paint6_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M252.81 146.743C258.636 139.781 267.762 135.237 278.023 132.563 288.155 129.917 289.971 123.666 283.258 121.638 275.646 119.337 266.147 123.566 260.02 129.443 249.344 139.686 248.008 147.526 248.008 147.526L252.81 146.743z",
    fill: "url(#paint7_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M252.81 146.743C258.636 139.781 267.762 135.237 278.023 132.563 288.155 129.917 289.971 123.666 283.258 121.638 275.646 119.337 266.147 123.566 260.02 129.443 249.344 139.686 248.008 147.526 248.008 147.526L252.81 146.743z",
    fill: "#000"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M249.804 146.334C249.762 146.334 249.715 146.322 249.674 146.304 249.526 146.233 249.467 146.055 249.538 145.907 258.185 128.114 277.318 123.737 281.972 124.07 282.138 124.081 282.256 124.224 282.244 124.39 282.233 124.556 282.079 124.675 281.925 124.663 277.383 124.313 258.581 128.654 250.064 146.168 250.023 146.275 249.916 146.334 249.804 146.334z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M248 148.594C248 149.851 249.36 150.616 250.443 149.981 255.86 146.82 263.762 145.071 276.555 148.718 283.356 150.658 286.704 149.359 288.135 146.583 289.726 143.499 286.355 140.516 282.511 139.11 269.422 134.312 257.611 137.586 248 147.158V148.594z",
    fill: "url(#paint8_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M248.745 148.849C248.662 148.849 248.585 148.813 248.526 148.748 248.42 148.624 248.426 148.44 248.55 148.327 259.852 138.197 277.359 140.172 283.983 144.122 284.125 144.205 284.172 144.389 284.084 144.531 284.001 144.674 283.817 144.715 283.675 144.632 277.181 140.759 260.024 138.838 248.94 148.772 248.887 148.819 248.816 148.849 248.745 148.849z",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M257.067 160.82C255.889 162.861 253.71 164.264 251.355 164.264H94.6419C92.2856 164.264 90.1108 162.861 88.9326 160.82 87.7516 158.78 87.7516 156.19 88.9326 154.15L167.285 18.3972C168.252 16.7271 169.883 15.5617 171.735 15.2016 172.146 15.1194 172.569 15.0698 172.998 15.0698 175.355 15.0698 177.534 16.3216 178.712 18.3646L257.068 154.151C258.245 156.193 258.245 158.78 257.067 160.82z",
    fill: "url(#paint9_linear)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M169.335 148.409C152.566 155.369 141.276 159.138 134.227 164.264H94.6419C92.2856 164.264 90.1108 162.861 88.9326 160.82 87.7516 158.78 87.7516 156.19 88.9326 154.15L167.285 18.3972C168.252 16.7271 169.883 15.5617 171.735 15.2016 164.863 28.7553 155.403 56.8353 178.866 79.3634 211.073 110.295 207.173 132.705 169.335 148.409z",
    fill: "url(#paint10_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M176.37 113.679 169.542 113.516C167.64 113.47 166.065 111.843 165.965 109.927L163.466 61.8201C163.414 60.8291 163.771 60.011 164.451 59.3405 165.13 58.6699 166.073 58.4544 167.059 58.5224L178.819 59.3419C179.783 59.4085 180.703 59.7289 181.364 60.4817 182.024 61.2331 182.37 62.1363 182.321 63.106L179.889 110.337C179.789 112.225 178.246 113.724 176.37 113.679z",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M165.834 125.431C167.539 123.803 169.938 123.015 173.023 123.064 176.203 123.115 178.613 123.953 180.264 125.577 181.91 127.194 182.73 129.559 182.73 132.674 182.73 135.677 181.891 138 180.208 139.648 178.521 141.299 176.129 142.127 173.023 142.127 169.975 142.127 167.586 141.274 165.862 139.561 164.134 137.844 163.268 135.495 163.268 132.519 163.268 129.426 164.124 127.064 165.834 125.431z",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M248.256 64.9449C251.021 88.5457 275.598 106.047 304.367 103.949 334.579 101.744 357.758 78.9702 354.734 53.1846 351.714 27.399 323.86 10.2598 293.907 14.7 265.391 18.9319 245.492 41.3442 248.256 64.9449z",
    fill: "url(#paint11_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M248.256 64.9449C251.021 88.5457 275.598 106.047 304.367 103.949 334.579 101.744 357.758 78.9702 354.734 53.1846 351.714 27.399 323.86 10.2598 293.907 14.7 265.391 18.9319 245.492 41.3442 248.256 64.9449z",
    fill: "#ecf8ff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M281.338 98.8675C281.338 98.8675 270.59 113.972 251.449 103.545 251.449 103.545 264.562 93.0915 263.752 80.7032L281.338 98.8675z",
    fill: "#ecf8ff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M290.23 93.6393C295.023 80.0113 287.206 68.4208 294.761 59.0471 302.549 49.3851 315.134 56.1607 327.066 47.5174 331.747 44.128 336.732 38.0733 339.634 26.4315 347.915 33.2775 353.486 42.5358 354.734 53.1877 357.754 78.9734 334.579 101.748 304.367 103.952 297.653 104.442 291.177 103.868 285.168 102.411 287.693 99.425 289.251 96.4296 290.23 93.6393z",
    fill: "#a2eaf3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0469 188.462 65.8092 181.221 43.5458 203.485 50.786 210.725 73.0469 188.462z",
    fill: "#313346"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9453 190.562 63.7077 183.322 41.4443 205.585 48.6845 212.826 70.9453 190.562z",
    fill: "#3f4159"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 196.074 58.2623 188.834 35.9989 211.097 43.2392 218.338 65.5 196.074z",
    fill: "#0e347d"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8836 188.968C80.5022 188.968 65.6011 174.066 65.6011 155.685c0-18.381 14.9011-33.282 33.2825-33.282C117.265 122.403 132.166 137.304 132.166 155.685 132.166 174.066 117.265 188.968 98.8836 188.968z",
    fill: "#64b5f6",
    fillOpacity: 0.25
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8534 136.897C85.2057 131.777 91.6062 128.705 98.5187 128.705 105.431 128.705 111.832 131.777 116.184 136.897 117.208 137.921 116.952 139.713 115.928 140.482 114.904 141.506 113.112 141.25 112.344 140.225 108.759 136.129 103.895 133.825 98.5187 133.825 93.1423 133.825 88.278 136.129 84.6937 140.225 84.1817 140.738 83.4136 141.25 82.6455 141.25 82.1335 141.25 81.3655 140.994 81.1094 140.738 80.0854 139.713 80.0854 137.921 80.8534 136.897z",
    fill: "#bbdefb",
    fillOpacity: 0.5
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.1618 198.027C121.365 198.027 140.175 179.217 140.175 156.013 140.175 132.81 121.365 114 98.1618 114 74.9584 114 56.1484 132.81 56.1484 156.013 56.1484 179.217 74.9584 198.027 98.1618 198.027zM65.6015 155.685C65.6015 174.066 80.5025 188.968 98.8839 188.968 117.265 188.968 132.166 174.066 132.166 155.685 132.166 137.304 117.265 122.403 98.8839 122.403 80.5025 122.403 65.6015 137.304 65.6015 155.685z",
    fill: "#3f4159"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 132.272,
    y1: 96.8923,
    x2: 19.3827,
    y2: 96.8923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0f347d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1bd4ed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 133.956,
    y1: 116.757,
    x2: 9.79305,
    y2: 116.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0f347d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1bd4ed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 159.001,
    y1: 110.442,
    x2: 308.704,
    y2: 110.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#f36f56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 270.808,
    y1: 88.3126,
    x2: 245.506,
    y2: 158.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5917,
    stopColor: "#f8924f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#f36f56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 244.669,
    y1: 78.3642,
    x2: 217.867,
    y2: 152.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5917,
    stopColor: "#f8924f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#f36f56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 234.394,
    y1: -32.5909,
    x2: 228.946,
    y2: 144.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#f36f56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 186.712,
    y1: 56.7445,
    x2: 243.884,
    y2: 56.7445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#f36f56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 295.236,
    y1: 134.157,
    x2: 238.28,
    y2: 134.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0f347d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1bd4ed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 296.808,
    y1: 143.512,
    x2: 237.946,
    y2: 143.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0f347d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1bd4ed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 88.0457,
    y1: 89.6673,
    x2: 257.951,
    y2: 89.6673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fcb148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    stopColor: "#fdba46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    stopColor: "#ffc244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    stopColor: "#ffc444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    stopColor: "#fdb946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#f99c4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    stopColor: "#f8924f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8924f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 88.0457,
    y1: 89.7335,
    x2: 200.609,
    y2: 89.7335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fcb148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    stopColor: "#fdba46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    stopColor: "#ffc244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    stopColor: "#ffc444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    stopColor: "#fdb946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#f99c4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    stopColor: "#f8924f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8924f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 316.945,
    y1: 20.196,
    x2: 259.89,
    y2: 163.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb6fbb"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoErrorStatus);
export default __webpack_public_path__ + "static/media/ico-error-status.de33deda0a384102de2f01b9ac85bee2.svg";
export { ForwardRef as ReactComponent };